// extracted by mini-css-extract-plugin
module.exports = {"ModalHeader":"Confirm_ModalHeader__1Cmvh","ModalBody":"Confirm_ModalBody__1jgE2","ButtonClose":"Confirm_ButtonClose__1gY96"};